import * as XLSX from 'xlsx';
import { PedidoModification } from '../Types';

const formatDateTime = (timestamp: string): string => {
  if (!timestamp) return 'N/A';
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return 'N/A';
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const getTipoModificacion = (isnegative: boolean): string => {
  return isnegative ? 'Negativa' : 'Positiva';
};

const transformModificationsData = (modifications: PedidoModification[]) => {
  return modifications.map(mod => ({
    'ID Modificación': mod.modification_id,
    'Usuario': mod.user_name || 'N/A',
    'Ejecutor': mod.approver_user_name || 'N/A',
    'Mesa': mod.mesa_tag || mod.mesa_number || mod.mesa_id || 'N/A',
    'Workstation': mod.workstation_id || 'N/A',
    'Detalle': mod.modification_detail || '',
    'Tipo': getTipoModificacion(mod.isnegative),
    'Monto': Math.round(mod.modification_amount || 0),
    'Fecha y Hora': formatDateTime(mod.timestamp)
  }));
};

export const exportModificationsToExcel = (
  modifications: PedidoModification[],
  startDate: string,
  endDate: string
) => {
  try {
    // Transform data
    const data = transformModificationsData(modifications);

    // Create workbook and worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);

    // Set column widths
    ws['!cols'] = [
      { wch: 15 }, // ID Modificación
      { wch: 20 }, // Usuario
      { wch: 20 }, // Ejecutor
      { wch: 10 }, // Mesa
      { wch: 15 }, // Workstation
      { wch: 40 }, // Detalle
      { wch: 12 }, // Tipo
      { wch: 12 }, // Monto
      { wch: 18 }  // Fecha y Hora
    ];

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Modificaciones');

    // Generate filename with date range
    const filename = `Modificaciones_Pedidos_${startDate}_a_${endDate}.xlsx`;

    // Write file
    XLSX.writeFile(wb, filename);

    return true;
  } catch (error) {
    console.error('Error exporting to Excel:', error);
    return false;
  }
};

export const exportFilteredModifications = (
  modifications: PedidoModification[],
  startDate: string,
  endDate: string
) => {
  if (modifications.length === 0) {
    return false;
  }
  return exportModificationsToExcel(modifications, startDate, endDate);
};
